import { useContext } from "react";
import { MdArrowForward } from "react-icons/md";
import { AppContext } from "../App";

export default function CallToAction() {
  const appContext = useContext(AppContext);

  return (
    <section className="tgm-thin-cta" data-aos="fade-up">
      <div className="container">
        <div className="tgm-thin-cta-shell">
          <div>
            <span>Ready to plan your next project?</span>
            <strong>
              Talk to SMART TGM Limited about civil works, building
              construction, or project management support.
            </strong>
          </div>
          <button
            type="button"
            className="tgm-solid-btn"
            onClick={() => appContext.navTo({ item: "contact_us" })}
          >
            Contact us <MdArrowForward />
          </button>
        </div>
      </div>
    </section>
  );
}
